/* eslint-disable import/prefer-default-export */
import { useState, useEffect, useCallback } from "react";
import { http } from "utils/http";

export const useCities = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [query, setQuery] = useState("");

  function fetchCities({ query: searchQuery }) {
    const porbableQuery = searchQuery || query;

    const url = `/city?${searchQuery}`;

    setQuery(porbableQuery);
    setLoading(true);

    http
      .get(url)
      .then(res => {
        setData(res.data);
      })
      .catch(err => setError(err))
      .finally(() => setLoading(false));
  }

  return [fetchCities, { loading, data, error }];
};
/**
  NearestCity: {
    name: String,
    id: Number,
    latitude: Number,
    longitude: Number,
  }
*/
export const useNearestCity = () => {
  /* @hakky REFACTOR  */
  const [nearestCity, setNearestCity] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const onPositionDetected = useCallback(
    position => {
      const { latitude, longitude } = position.coords;
      const url = `/location/nearest-city?userLatitude=${latitude}&userLongitude=${longitude}`;

      http
        .get(url)
        .then(({ data: nearestCityData }) => {
          setNearestCity(nearestCityData);

          localStorage.setItem("currentCity", JSON.stringify(nearestCityData));
          localStorage.setItem(
            "userLocation",
            JSON.stringify({ latitude, longitude })
          );
        })
        .catch(() => setError(true))
        .finally(() => setLoading(false));
    },
    [nearestCity, setNearestCity, setLoading]
  );

  const onPositionError = useCallback(() => {
    setLoading(false);
    setError(true);
  }, [setLoading, setError]);

  useEffect(() => {
    /* feature check */
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        onPositionDetected,
        onPositionError,
        { enableHighAccuracy: false, timeout: 6000, maximumAge: 0 }
      );
    }
  }, []);

  return {
    nearestCity,
    loading,
    error,
  };
};
